import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LiabilityWaiverState {
  liabilityWaiverModalOpened: boolean;
  liabilityWaiverViewed: boolean;
  liabilityWaiverAgreed: boolean;
}

const initialState: LiabilityWaiverState = {
  liabilityWaiverModalOpened: false,
  liabilityWaiverViewed: false,
  liabilityWaiverAgreed: false,
};

const liabilityWaiverSlice = createSlice({
  name: "liabilityWaiver",
  initialState,
  reducers: {
    openLiabilityWaiverModal: (state) => {
      return {
        ...state,
        liabilityWaiverModalOpened: true,
        liabilityWaiverAgreed: false,
        liabilityWaiverViewed: false,
      };
    },
    setLiabilityWaiverModalOpened: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        liabilityWaiverModalOpened: action.payload,
      };
    },
    setLiabilityWaiverViewed: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        liabilityWaiverViewed: action.payload,
      };
    },
    setLiabilityWaiverAgreed: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        liabilityWaiverAgreed: action.payload,
      };
    },
  },
});

export const {
  openLiabilityWaiverModal,
  setLiabilityWaiverModalOpened,
  setLiabilityWaiverViewed,
  setLiabilityWaiverAgreed,
} = liabilityWaiverSlice.actions;

export default liabilityWaiverSlice;
